import { http } from "@/lib/http";
export function fetchTasks() {
  return http.get("/api/tasks/get_all").then((res) => res.data);
}
export function deleteTask(id) {
  return http.delete(`/api/tasks/delete/${id}`).then((res) => res.data);
}
export function fetchTaskReminders() {
  return http.get("/api/reminders/get_all").then((res) => res.data);
}
export function fetchTaskGroup(id) {
  return http.post("/api/tasks/get/mid", { mid: id }).then((res) => res.data);
}
export function addTaskGroup(payload) {
  return http.post("/api/tasks/add", payload).then((res) => res.data);
}
export function editTaskGroup(payload) {
  return http.post("/api/tasks/edit", payload).then((res) => res.data);
}
export function editReminderAudience({
  userGuids,
  startDate,
  endDate,
  itemId,
}) {
  return http
    .post("/api/reminders/edit", {
      userGuids: userGuids || [],
      startDate,
      endDate,
      itemId,
    })
    .then((res) => res.data);
}
